import { render, staticRenderFns } from "./BillingDetail.vue?vue&type=template&id=987db190&scoped=true&"
import script from "./BillingDetail.vue?vue&type=script&lang=js&"
export * from "./BillingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetail.vue?vue&type=style&index=0&id=987db190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987db190",
  null
  
)

export default component.exports